import React, { useMemo, ReactNode, createContext, useContext } from "react";

import { AppEndpointAddonMasterRaw } from "@/domain/AppEndpointAddonMaster";
import { useAdminAPI } from "../hooks";

const ctx = createContext<{
  appEndpointAddonMasters: AppEndpointAddonMasterRaw[] | null;
  runReloadAppEndpointAddonMasters: () => Promise<void>;
  isLoadedAppEndpointAddonMasters: boolean;
}>({
  appEndpointAddonMasters: null,
  runReloadAppEndpointAddonMasters: async () => {},
  isLoadedAppEndpointAddonMasters: false,
});

export const AdminAppEndpointAddonMastersProvider: React.FC<{
  children: ReactNode;
}> = ({ children }) => {
  const {
    state: appEndpointAddonMasters,
    runReloadState: runReloadAppEndpointAddonMasters,
    isLoadedState: isLoadedAppEndpointAddonMasters,
  } = useAdminAPI<AppEndpointAddonMasterRaw[]>("appEndpointAddonMasters");

  const ctxValue = useMemo(
    () => ({
      appEndpointAddonMasters,
      runReloadAppEndpointAddonMasters,
      isLoadedAppEndpointAddonMasters,
    }),
    [
      appEndpointAddonMasters,
      runReloadAppEndpointAddonMasters,
      isLoadedAppEndpointAddonMasters,
    ]
  );

  return <ctx.Provider value={ctxValue}>{children}</ctx.Provider>;
};

export const useAdminAppEndpointAddonMasters = () => {
  return useContext(ctx);
};
